import { create } from 'vue-modal-dialogs';
import confirmUI from '@/components/dialogs/confirm';
import alertUI from '@/components/dialogs/alert';

const confirm = create(confirmUI),
    alert = create(alertUI),
    dialogs = {
        install(Vue) {
            Vue.prototype.$dialog = {
                confirm,
                alert,
            };
        },
    };

export default dialogs;
